import React from 'react';

/**
 * The ▾ on a button that opens a menu, drawn rather than typed (UX review
 * round 24): the glyph came out ~5px wide in Geist and read as a dot, so
 * "Edit", "Write a post" and the site name didn't look like menus.
 */
export function MenuCaret({ className }: { className?: string }) {
  return (
    <svg
      className={className ? `menu-caret ${className}` : 'menu-caret'}
      width="10"
      height="6"
      viewBox="0 0 10 6"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M1 1l4 4 4-4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
